module.exports = __webpack_public_path__ + "static/5e95cd43b3d92.image-1377b7f95f633fa441f84468f8898349.jpg";